import BlCheckboxAv from './BlCheckboxAv.vue'

BlCheckboxAv.install = function(Vue) {
  Vue.component(BlCheckboxAv.name, BlCheckboxAv)
}

export default BlCheckboxAv
